var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid"},[_c('main-header'),(_vm.currentPage === 'intro')?_c('social-login-validation',{on:{"current-page":_vm.receiveData}}):_vm._e(),(_vm.currentPage === 'hmm')?_c('join-point-calculate',{on:{"current-page":_vm.receiveData}}):_vm._e(),(_vm.currentPage === 'fin')?_c('completion-screen-point'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }